// DESCRIPTION: Block entry point — registers the nemtly/event-calendar Gutenberg block.

import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import metadata from './block.json';

registerBlockType( metadata.name, {
	edit: Edit,
	save: () => null, // Server-rendered dynamic block.
} );
